import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'

const Tab = ({ to, children }: { to: string; children: React.ReactNode }) => {
  const location = useLocation()

  return (
    <Link
      to={to}
      className={classNames(
        location.pathname === to
          ? 'text-gray-800 font-semibold border-gearflow'
          : 'border-transparent text-gray-600 hover:text-gray-700 hover:border-gray-400',
        'whitespace-nowrap pt-4 py-3 px-3 border-b-2 font-medium text-base focus:outline-none'
      )}
      role="tab"
    >
      {children}
    </Link>
  )
}

const Menu = () => (
  <div className="border-b border-gray-300" role="tablist" aria-orientation="horizontal">
    <div className="-mb-px flex space-x-8">
      <Tab to="/customers">Contacts</Tab>
      <Tab to="/accounts">Accounts</Tab>
    </div>
  </div>
)

export default Menu
